import React, { useEffect, useState } from 'react';
import { Link, RouteChildrenProps } from 'react-router-dom';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';
import { Box, constants, Typography } from '@match/react-component-library';
import api from 'utils/api-services';
import { SubCategory } from 'types';
import { FAQ_CONSTANTS } from 'modules/constants';
import { Topics } from 'modules/components';
import { useCurrentCategoryName } from 'modules/hooks';

const { ZERO } = FAQ_CONSTANTS;

const { FONT_SIZE, FONT_WEIGHT, SEMANTIC_COLOR_NAME, SPACE } = constants;

interface RouteParams {
  categoryId?: string;
}

const MobiSubCategoryPage: React.FunctionComponent<RouteChildrenProps<RouteParams>> = ({
  match,
}) => {
  const intl = useIntl();
  const { currentCategoryName } = useCurrentCategoryName();

  const [currentSubCategories, setSubcategories] = useState<SubCategory[]>([]);
  const [error, setError] = useState('');

  let currentCategoryId: number | 0 | string | undefined;
  if (match) {
    const isRouteZero = match.params.categoryId === ZERO ? true : false;
    currentCategoryId =
      match.params.categoryId && !isRouteZero ? Number(match.params.categoryId) : 0;
  }

  useEffect(() => {
    if (currentCategoryId) {
      api
        .getFaqCategory(currentCategoryId)
        .then((res) => {
          setSubcategories(
            res.map((subcategory) => ({
              ...subcategory,
              categoryId: currentCategoryId,
            })) as SubCategory[]
          );
        })
        .catch(() => setError('Invalid category'));
    } else {
      api
        .getMostPopular()
        .then((res) => {
          const mostPopularSubCat = [
            {
              id: 0,
              name: intl.formatMessage(messages.mostPopular),
              topics: res,
            },
          ];
          setSubcategories(mostPopularSubCat as SubCategory[]);
        })
        .catch(() => setError('Invalid category'));
    }
  }, [currentCategoryId]);

  const subCategories =
    currentSubCategories &&
    currentSubCategories.map((subCategory, index) => {
      const subCategoryId = subCategory.id;
      const topics = subCategory.topics;

      return (
        <li key={subCategoryId}>
          <Box
            borderBottom={currentSubCategories.length > 1 ? '2px solid' : undefined}
            borderColor={SEMANTIC_COLOR_NAME.GRAY_10}
            paddingBottom={SPACE.XXLARGE}
            paddingTop={index === 0 ? SPACE.NONE : SPACE.XXLARGE}
            paddingX={SPACE.LARGE}
          >
            <Typography fontSize={FONT_SIZE.LARGE} fontWeight={FONT_WEIGHT.BOLD}>
              {subCategory.name}
            </Typography>
            <Topics key={index} topics={topics} />
          </Box>
        </li>
      );
    });

  if (error) console.log(error);

  return (
    <React.Fragment>
      <Box paddingLeft={SPACE.LARGE} paddingBottom={SPACE.MEDIUM}>
        <Typography as="p" color={SEMANTIC_COLOR_NAME.GRAY_75}>
          <Link to="/">
            <Typography color={SEMANTIC_COLOR_NAME.GRAY_75}>
              <FormattedMessage {...messages.help} />
            </Typography>
          </Link>{' '}
          &gt; {currentCategoryName}
        </Typography>
      </Box>
      <ul>{subCategories}</ul>
    </React.Fragment>
  );
};

export default MobiSubCategoryPage;

const messages = defineMessages({
  mostPopular: {
    id: 'src/modules/pages/MobiSubCategoryPage/MobiSubCategoryPage:mostPopular',
    description: 'most popular category text',
    defaultMessage: 'Most Popular',
  },
  help: {
    id: 'src/modules/pages/MobiSubCategoryPage/MobiSubCategoryPage:help',
    description: 'back to categories link text',
    defaultMessage: 'Help',
  },
});
